import React, { useId } from 'react'
import { SuperGrain } from '../SuperGrain'

export const SimpleTurquoise = ({
  svgProps,
  hideGrain,
}: {
  svgProps: React.SVGProps<SVGSVGElement>
  hideGrain?: boolean
}) => {
  const uniqueId = useId()
  const grainMaskId1 = `grainFilter-simple-turquoise-1-${uniqueId}`

  return (
    <svg
      {...svgProps}
      viewBox="0 0 2085 1458"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <filter
          id="filter0_f_5717_4078"
          x="117"
          y="171"
          width="1724"
          height="1188"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="150"
            result="effect1_foregroundBlur_5717_4078"
          />
        </filter>
        <filter
          id="filter1_f_5717_4078"
          x="244"
          y="100"
          width="1724"
          height="1188"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="150"
            result="effect1_foregroundBlur_5717_4078"
          />
        </filter>
        <mask id={grainMaskId1}>
          <rect width="100%" height="100%" fill="black" />
          <g filter="url(#filter0_f_5717_4078)">
            <ellipse cx="979" cy="765" rx="562" ry="294" fill="white" />
          </g>
          <g filter="url(#filter1_f_5717_4078)">
            <ellipse cx="1106" cy="694" rx="562" ry="294" fill="white" />
          </g>
        </mask>
      </defs>

      <g opacity="0.3" filter="url(#filter0_f_5717_4078)">
        <ellipse cx="979" cy="765" rx="562" ry="294" fill="#7FD1FE" />
      </g>
      <g opacity="0.3" filter="url(#filter1_f_5717_4078)">
        <ellipse cx="1106" cy="694" rx="562" ry="294" fill="#176BE5" />
      </g>

      {!hideGrain && (
        <foreignObject
          x="0"
          y="0"
          width="100%"
          height="100%"
          opacity={0.7}
          mask={`url(#${grainMaskId1})`}
        >
          <SuperGrain zIndex={0} />
        </foreignObject>
      )}
    </svg>
  )
}
